import { mapQuery } from 'utils/query';
import { Details } from 'components/details';
import { Drawer, DrawerHeader } from 'components/drawer';
import { useReceiptDetailsQuery } from 'store/api/event';
import { ReceiptDetails } from 'components/receipt-details';

import { SaleDetailsDrawerProps } from './types';

export const SaleDetailsDrawer = ({
  selectedReceipt,
  setSelectedReceipt,
  ...drawerProps
}: SaleDetailsDrawerProps) => {
  const { data, ...props } = useReceiptDetailsQuery(
    {
      id: Number(selectedReceipt?.eventId),
      receiptId: String(selectedReceipt?.id),
    },
    { skip: !selectedReceipt?.eventId || !selectedReceipt?.id }
  );

  return (
    <Drawer
      topOffset="20%"
      opened={!!selectedReceipt}
      onClose={() => setSelectedReceipt(undefined)}
      {...drawerProps}
    >
      <DrawerHeader
        title="Sale Details"
        onClose={() => setSelectedReceipt(undefined)}
      />

      <Details {...mapQuery(props)}>
        <ReceiptDetails
          data={data}
          hideActionButtons
          hasPadding={false}
          receiptId={String(data?.id)}
          eventId={String(data?.eventId)}
        />
      </Details>
    </Drawer>
  );
};
